(function () {
    var revealSelector = [
        'main h1',
        'main h2',
        'main h3',
        'main p',
        'main li',
        'main img',
        'main form',
        'main button',
        'main a[class*="button"]',
        '.vitalify-main-content__breadcrumb',
        '.vitalify-main-content__eyebrow',
        '.vitalify-main-content__title',
        '.vitalify-main-content__rte > *',
        '.vitalify-about__title',
        '.vitalify-about__media',
        '.vitalify-about__body > *',
        '.vitalify-login__title',
        '.vitalify-login__text',
        '.vitalify-collection__breadcrumb',
        '.vitalify-collection__title',
        '.vitalify-collection__toolbar',
        '.vitalify-collection__filters-title',
        '.vitalify-collection__filter-group',
        '.vitalify-collection-card',
        '.vitalify-collection__pagination',
        '.vitalify-home-categories__eyebrow',
        '.vitalify-home-categories__heading',
        '.vitalify-home-categories__text',
        '.vitalify-home-categories__card',
        '.vitalify-home-product-slider__eyebrow',
        '.vitalify-home-product-slider__heading',
        '.vitalify-home-product-slider__text',
        '.vitalify-home-product-card',
        '.vitalify-home-product-slider__button',
        '.vitalify-product-related__eyebrow',
        '.vitalify-product-related__heading',
        '.vitalify-product-related__text',
        '.vitalify-product-related-card',
        '.vitalify-product-related__nav-button',
        '.vitalify-home-offer__slide.is-active .vitalify-home-offer__eyebrow',
        '.vitalify-home-offer__slide.is-active .vitalify-home-offer__heading',
        '.vitalify-home-offer__slide.is-active .vitalify-home-offer__text',
        '.vitalify-home-offer__slide.is-active .vitalify-home-offer__feature',
        '.vitalify-home-offer__slide.is-active .vitalify-home-offer__image',
        '.vitalify-home-offer__slide.is-active .vitalify-home-offer__price-block',
        '.vitalify-home-offer__slide.is-active .vitalify-home-offer__installments',
        '.vitalify-home-offer__slide.is-active .vitalify-home-offer__actions',
        '.vitalify-home-offer__slide.is-active .vitalify-home-offer__microcopy',
        '.vitalify-home-reviews__topline',
        '.vitalify-home-reviews__intro',
        '.vitalify-home-reviews__list',
        '.vitalify-home-choose__media',
        '.vitalify-home-choose__heading',
        '.vitalify-home-choose__text',
        '.vitalify-home-instagram__heading',
        '.vitalify-second-section__value',
        '.vitalify-product-hero__media-stage',
        '.vitalify-product-hero__breadcrumb',
        '.vitalify-product-hero__eyebrow',
        '.vitalify-product-hero__title',
        '.vitalify-product-hero__price-group',
        '.vitalify-product-hero__pix',
        '.vitalify-product-hero__installments',
        '.vitalify-product-hero__rating',
        '.vitalify-product-hero__form',
        '.vitalify-product-hero__details',
        '.vitalify-product-story__heading',
        '.vitalify-product-story__text > *',
        '.vitalify-product-story__image',
        '.vitalify-product-reviews__heading',
        '.vitalify-product-reviews__widget-shell',
        '.vitalify-main-cart__title',
        '.vitalify-main-cart__item',
        '.vitalify-main-cart__summary',
        '.vitalify-main-cart__reviews'
    ].join(',');

    var headerRevealSelector = [
        '.vitalify-header__top-bar',
        '.vitalify-header__brand',
        '.vitalify-header__menu-item',
        '.vitalify-header__actions > *',
        '.vitalify-header__menu-toggle'
    ].join(',');

    var excludedClosestSelector = [
        '[data-cart-drawer]',
        '[data-sticky-atc]',
        '[data-cookie-popup]',
        '[data-search-overlay]',
        '[data-header-menu-drawer]',
        '.vitalify-collection',
        '.vitalify-home-hero__ticker-wrap',
        '.vitalify-floating-whatsapp',
        '.swiper-pagination',
        '.vitalify-home-reviews__quote-word',
        '.vitalify-product-gallery__thumbs-wrap',
        '.vitalify-product-gallery__thumbs',
        '[data-product-gallery-thumbs]',
        '.vitalify-product-hero__buy-panel',
        '.vitalify-product-form',
        '.vitalify-quantity',
        '.es-popup-button',
        '.vitalify-sticky-atc'
    ].join(',');

    var productCardSelector = [
        '.vitalify-home-product-card',
        '.vitalify-product-related-card',
        '.vitalify-collection-card',
        '.vitalify-cart-recommendation'
    ].join(',');

    var scanQueued = false;
    var scanBound = false;

    function prefersReducedMotion() {
        return window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    }

    function isMeasurable(element) {
        if (!element || element.hidden) {
            return false;
        }

        var styles = window.getComputedStyle(element);
        var rect = element.getBoundingClientRect();

        return styles.display !== 'none' &&
            styles.visibility !== 'hidden' &&
            rect.width > 0 &&
            rect.height > 0;
    }

    function shouldReveal(element) {
        var productCard = element.closest(productCardSelector);

        if (productCard && productCard !== element) {
            return false;
        }

        return element &&
            element.dataset.siteRevealInitialized !== 'true' &&
            element.closest('main') &&
            !element.closest(excludedClosestSelector) &&
            isMeasurable(element);
    }

    function isInRevealZone(element) {
        var rect = element.getBoundingClientRect();
        var viewportHeight = window.innerHeight || document.documentElement.clientHeight;

        return rect.top < viewportHeight * 0.86 && rect.bottom > viewportHeight * 0.08;
    }

    function collectRevealElements(root) {
        var scope = root || document;
        var elements = [];

        if (scope.matches && scope.matches(revealSelector)) {
            elements.push(scope);
        }

        scope.querySelectorAll(revealSelector).forEach(function (element) {
            elements.push(element);
        });

        return Array.from(new Set(elements)).filter(shouldReveal);
    }

    function animateIn(element, vars) {
        if (element.dataset.siteRevealComplete === 'true') {
            return;
        }

        element.dataset.siteRevealComplete = 'true';
        window.gsap.fromTo(element, {
            autoAlpha: 0,
            y: vars.y || 34,
            scale: vars.scale || 0.985,
            filter: 'blur(0px)'
        }, {
            autoAlpha: 1,
            y: 0,
            scale: 1,
            filter: 'blur(0px)',
            duration: vars.duration || 0.78,
            delay: vars.delay || 0,
            ease: 'power2.out',
            overwrite: true,
            clearProps: 'filter,transform,visibility,opacity'
        });
    }

    function prepareRevealElement(element) {
        element.dataset.siteRevealInitialized = 'true';
        window.gsap.set(element, {
            autoAlpha: 0,
            y: 34,
            scale: 0.985,
            filter: 'blur(0px)'
        });
    }

    function revealElements(elements) {
        if (!elements.length) {
            return;
        }

        elements.forEach(prepareRevealElement);

        if (!('IntersectionObserver' in window)) {
            elements.forEach(function (element, index) {
                animateIn(element, {
                    y: 28,
                    blur: 0,
                    duration: 0.72,
                    delay: Math.min(index * 0.02, 0.18)
                });
            });
            return;
        }

        var observer = new IntersectionObserver(function (entries) {
            entries.forEach(function (entry) {
                if (!entry.isIntersecting) {
                    return;
                }

                observer.unobserve(entry.target);
                animateIn(entry.target, {
                    y: 34,
                    blur: 0,
                    duration: 0.78
                });
            });
        }, {
            root: null,
            rootMargin: '0px 0px -14% 0px',
            threshold: 0.04
        });

        elements.forEach(function (element) {
            observer.observe(element);
        });
    }

    function revealPreparedElementsInView() {
        document.querySelectorAll('[data-site-reveal-initialized="true"]:not([data-site-reveal-complete="true"])').forEach(function (element) {
            if (isMeasurable(element) && isInRevealZone(element)) {
                animateIn(element, {
                    y: 34,
                    blur: 0,
                    duration: 0.78
                });
            }
        });
    }

    function queueScan() {
        if (scanQueued) {
            return;
        }

        scanQueued = true;
        window.requestAnimationFrame(function () {
            scanQueued = false;
            revealPreparedElementsInView();
        });
    }

    function bindScanEvents() {
        if (scanBound) {
            return;
        }

        scanBound = true;
        window.addEventListener('scroll', queueScan, { passive: true });
        window.addEventListener('resize', queueScan);
    }

    function revealHeroTicker(root) {
        var scope = root || document;
        var ticker = scope.matches && scope.matches('.vitalify-home-hero__ticker-wrap')
            ? scope
            : scope.querySelector && scope.querySelector('.vitalify-home-hero__ticker-wrap');

        if (!ticker || ticker.dataset.siteRevealInitialized === 'true' || !isMeasurable(ticker)) {
            return;
        }

        ticker.dataset.siteRevealInitialized = 'true';
        ticker.querySelectorAll('[data-site-reveal-initialized="true"]').forEach(function (element) {
            element.dataset.siteRevealComplete = 'true';
            window.gsap.set(element, {
                clearProps: 'filter,transform,visibility,opacity'
            });
        });

        animateIn(ticker, {
            y: 18,
            blur: 0,
            duration: 0.72
        });
    }

    function revealHeader(root) {
        var scope = root || document;
        var headerElement = scope.matches && scope.matches('[data-site-header]')
            ? scope
            : scope.querySelector && scope.querySelector('[data-site-header]');

        if (!headerElement || headerElement.dataset.headerRevealComplete === 'true') {
            return;
        }

        var elements = Array.prototype.slice.call(headerElement.querySelectorAll(headerRevealSelector))
            .filter(isMeasurable);

        if (!elements.length) {
            return;
        }

        headerElement.dataset.headerRevealComplete = 'true';
        elements.forEach(function (element) {
            element.dataset.headerRevealInitialized = 'true';
        });

        window.gsap.fromTo(elements, {
            autoAlpha: 0,
            y: -14,
            filter: 'blur(0px)'
        }, {
            autoAlpha: 1,
            y: 0,
            filter: 'blur(0px)',
            duration: 0.72,
            stagger: 0.045,
            ease: 'power2.out',
            clearProps: 'filter,transform,visibility,opacity'
        });
    }

    function initSiteReveal(root) {
        if (!window.gsap || prefersReducedMotion()) {
            return;
        }

        revealHeader(root);
        revealHeroTicker(root);
        revealElements(collectRevealElements(root));
        revealPreparedElementsInView();
        bindScanEvents();
    }

    window.VitalifySiteReveal = {
        init: initSiteReveal
    };

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', function () {
            initSiteReveal(document);
        });
    } else {
        initSiteReveal(document);
    }

    window.addEventListener('load', function () {
        initSiteReveal(document);
    });

    window.setTimeout(function () {
        initSiteReveal(document);
    }, 700);

    document.addEventListener('shopify:section:load', function (event) {
        initSiteReveal(event.target);
    });
})();
